import { Action, ThunkAction, ThunkDispatch } from "@reduxjs/toolkit";

import { ReduxState, ThunkExtraArgument } from "@dashboard/types";

import { fetchResolvedEdibles } from "./resolvedEdibleActions";
import { fetchSuppliers } from "./supplierActions";

type InitialFetchThunkAction = ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  Action
>;

export type InitialFetchThunkDispatch = ThunkDispatch<
  ReduxState,
  ThunkExtraArgument,
  Action
>;

// An action that fetches all the data needed to display
// most of the dashboard like menus, dishes, products, analytics, etc.
export const initialFetchForReduxState: () => InitialFetchThunkAction = () => {
  return (dispatch: InitialFetchThunkDispatch) => {
    // Resolved edibles are polled rather than listened to because the backend
    // resolves them against the global taxonomy snapshot as well as this
    // restaurant's products and dishes. A taxonomy change alters the result
    // with no document write to listen for, so only the refetch catches it.
    dispatch(fetchResolvedEdibles());
    dispatch(fetchSuppliers()); // This is needed to show suppliers in ProductDrawer.
  };
};
